import RenderLoop from './RenderLoop'

const renderLoop = new RenderLoop()

export type EasingType = (t: number, b: number, c: number, d: number) => number

export const Easing = {
	linear: (t: number, b: number, c: number, d: number): number => {
		return Math.min(1, t / d)
	},
	easeInSine: (t: number, b: number, c: number, d: number): number => {
		return -c * Math.cos(t/d * (Math.PI/2)) + c + b;
	},
	easeOutSine: (t: number, b: number, c: number, d: number): number => {
		return c * Math.sin(t/d * (Math.PI/2)) + b;
	},
	easeInQuad: (t: number, b: number, c: number, d: number): number => {
		t /= d;
		return c*t*t + b;
	},
	easeOutQuad: (t: number, b: number, c: number, d: number): number => {
		t /= d;
		return -c * t*(t-2) + b;
	}
}

let counter = 0
export const interpolate = (from: number, to: number, transition: any, onChange: (value: number) => void) => {
	counter += 1

	const id = `tween-${counter}`
	const opts = {
		duration: 1.0,
		easing: 'linear',
		delay: 0,
		...transition
	}

	const duration = opts.duration * 1000
	const delay = opts.delay * 1000

	let timingFunc = (typeof opts.easing === 'string') ? Easing[opts.easing] : opts.easing
	if (!timingFunc || typeof timingFunc !== 'function') {
		timingFunc = Easing.linear
	}

	const startTime = new Date().getTime()

	renderLoop.add(id, null, (t) => {
		const elapsed = (t - delay) - startTime
		const progress = Math.max(0, Math.min(1, timingFunc(elapsed, 0, 1, duration)));
		const val = from + (to - from) * progress

		onChange(val)

		if (progress >= 1 || elapsed >= duration) {
			onChange(to)
			renderLoop.remove(id)
		}
	})
}
